import { withInstall } from '../../../../utils/with-install'
import Flexible from './Flexible.vue'

export const ElAmapLayerFlexible = withInstall(Flexible)
export default ElAmapLayerFlexible
